import React, { useEffect, useRef, useState } from "react";
import { FormHandles } from "@unform/core";

import { useForm } from "react-hook-form";

import { TextsProps } from "../../../database/txt.interface";
import { useDispatch, useSelector } from "react-redux";

import { AddPacAvalActions } from "../../../store/ducks/add_pac_aval";
import InputSelectForm from "../../../components/SelectComponent/InputSelectForm";
import {
	PacientesProps,
	UserProps,
} from "../../../interfaces/pacientes.interface";
import { DashBoardActions } from "../../../store/ducks/dashboard";
import FormSubmiteButton from "../../../components/Buttons/FormSubmitButton";
import { AmplitudeLog } from "../../../utils/amplitude";

import {
	ContainerGoBack,
	ContainerIcon,
	ContainerInfos,
	ContainerPageDetailPatient,
	Content,
	PageName,
	Title,
} from "./styles";

import Text from "../../../components/Texts/Text";
import Form from "../../../components/Form";
import InputTextEntryForm from "../../../components/Inputs/inputForm";
import ModalSaveChangeEditPatient from "../../../components/Modais/ModalSaveChangesPatientEdit";

import { ReactComponent as ArrowBack } from "../../../assets/kinologyIcons/svg/arrow_back.svg";
import { ReactComponent as Edit } from "../../../assets/kinologyIcons/svg/edit.svg";
import { ReactComponent as UserWhitoutPhoto } from "../../../assets/kinologyIcons/svg/patient.svg";
import { ReactComponent as Camera } from "../../../assets/kinologyIcons/svg/photo_camera.svg";
import ReturnIcon from "../../../assets/icons/back_page.svg";
import { Colors } from "../../../styles/colors";
import { ContainerDash, Icon, Return } from "../../../styles/global";
import { P1Desk, P2Desk, P3Desk } from "../../../styles/styles_text";
import { formatDominant, formatDominantForSave } from "../../../utils/funcs";
import { ServicosProps } from "../../../interfaces/config.interface";

interface PropsFildInputs {
	birth_date?: string;
	EditMassa?: string;
	EditAltura?: string;
	EditCelular?: string;
	cpf?: string;
	EditNome?: string;
	EditEmail?: string;
	EditSexo?: string;
	EditLadoDominanteSup?: string;
	EditLadoDominanteInf?: string;
	EditEntranceDoor?: string;
	EditMatricula?: string;
	EditManagement?: string;
}

const InformacoesPaciente: React.FC = () => {
	const current_language: TextsProps = useSelector(
		(state: any) => state.configs.current_language
	);
	const methods = useForm();
	const dispatch = useDispatch();
	const inputRef = useRef<HTMLInputElement>(null);
	const formRef = useRef<FormHandles>(null);

	const config_servicos: ServicosProps = useSelector(
		(state: any) => state.configs.config_servicos
	);

	const user_logado: UserProps = useSelector((state: any) => state.auth.user);

	const paciente: PacientesProps = useSelector(
		(state: any) => state.app.is_open_paciente
	);
	const user_eval_avatar_64 = useSelector(
		(state: any) => state.add_pac_aval.user_eval_avatar_64
	);

	const management = useSelector((state: any) => state.dashboard.gerencias);

	const entrance_door_data = useSelector(
		(state: any) => state.dashboard.entrance_door_data
	);

	const positionsDynalabs = useSelector((state: any) => state.dashboard.cargos);

	const conditioning = [
		"",
		current_language?.menu_lateral_atleta,
		current_language?.menu_lateral_ativo,
		current_language?.menu_lateral_pos_operatorio,
		current_language?.menu_lateral_sedentario,
		current_language?.menu_lateral_idoso,
	];
	const Sex = [
		current_language?.options_sexo_mas,
		current_language?.options_sexo_fem,
	];
	const DominantSides = [current_language?.canhoto, current_language?.destro];

	const [img, setImg] = useState<any>(paciente?.USUARIO_FOTO);
	const [disabled, setDisabled] = useState(true);
	const [load, setLoad] = useState(false);
	const [clickAddPhoto, setClickAddPhoto] = useState(false);
	const [submitForm, setSubmitForm] = useState(false);
	const [modalVisible, setModalVisible] = useState(false);
	const [condition, setCondition] = useState<string>("");
	const [dominant, setDominant] = useState<string>("");

	const [managementList, setManagementList] = useState([]);
	const [entranceDoorList, setEntranceDoorList] = useState([]);

	const [positionList, setPositionList] = useState([]);

	const isWorklabActive =
		user_logado?.USUARIO_NIVEL == "1" &&
		config_servicos?.SERVICO_DYNALAB == true;

	const values = methods.getValues();

	const objForCompare = {
		birth_date: paciente?.USUARIO_NASCIMENTO
			? paciente?.USUARIO_NASCIMENTO == "0000-00-00"
				? ""
				: current_language?.idioma === "Português"
				? `${paciente?.USUARIO_NASCIMENTO?.substr(0, 10)
						.split("-")
						.reverse()
						.join("/")}`
				: current_language?.idioma === "English"
				? `${paciente?.USUARIO_NASCIMENTO?.substr(5, 10)
						.split("-")
						.join("/")}/${paciente?.USUARIO_NASCIMENTO?.substr(0, 4)}`
				: `${paciente?.USUARIO_NASCIMENTO?.substr(0, 10)
						.split("-")
						.reverse()
						.join("-")}`
			: "",
		EditCelular: paciente?.USUARIO_CONTATO ? paciente?.USUARIO_CONTATO : "",
		cpf: paciente?.USUARIO_CPF ? paciente?.USUARIO_CPF : "",
		EditEmail: paciente?.USUARIO_EMAIL ? paciente?.USUARIO_EMAIL : "",
		EditNome: paciente?.USUARIO_NOME ? paciente?.USUARIO_NOME : "",
		EditMassa: paciente?.USUARIO_MASSA ? paciente?.USUARIO_MASSA : "",
		EditAltura: paciente?.USUARIO_ESTATURA ? paciente?.USUARIO_ESTATURA : "",
		EditSexo: paciente?.USUARIO_SEXO ? paciente?.USUARIO_SEXO : "",
		EditLadoDominanteSup: paciente?.USUARIO_LADO_DOMINANTE
			? formatDominant(paciente?.USUARIO_LADO_DOMINANTE, current_language)
			: "",
		EditLadoDominanteInf: paciente?.USUARIO_LADO_DOMINANTE_INF
			? formatDominant(paciente?.USUARIO_LADO_DOMINANTE_INF, current_language)
			: "",
		EditEntranceDoor: paciente?.ID_PORTA_ENTRADA
			? paciente?.ID_PORTA_ENTRADA
			: "",
		EditMatricula: paciente?.USUARIO_MATRICULA
			? paciente?.USUARIO_MATRICULA
			: "",
		EditManagement: paciente?.ID_GERENCIA ? paciente?.ID_GERENCIA : "",
	};

	function handleGoBack() {
		let changesDetected = false;
		for (const key in objForCompare) {
			if (
				values[key as keyof PropsFildInputs] !==
				objForCompare[key as keyof PropsFildInputs]
			) {
				changesDetected = true;
				break;
			}
		}
		if (changesDetected) {
			setModalVisible(true);
		} else {
			dispatch(DashBoardActions.set_current_page("perfil_paciente"));
		}
	}

	useEffect(() => {
		dispatch(AddPacAvalActions.set_photo(img));
	}, [img]);

	useEffect(() => {
		if (clickAddPhoto && inputRef.current) {
			inputRef.current.click();
			setClickAddPhoto(false);
		}
	}, [clickAddPhoto]);

	useEffect(() => {
		if (submitForm && !disabled) {
			methods.handleSubmit((data) => {
				onSubmit(data);
				setSubmitForm(false);
				setModalVisible(false);
			})();
		}
	}, [submitForm, methods]);

	function getBase64(event: any) {
		const file = event.target.files[0];
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = function () {
			setImg(reader.result);
			dispatch(AddPacAvalActions.set_avatar_eval_64(reader.result));
		};
		reader.onerror = function (error) {
			console.error("Error: ", error);
		};
	}
	function deletePhoto(event: any) {
		event.target.value = null;
	}

	const formatIMC = (weigth: string, heigth: string) => {
		return (
			parseFloat(weigth) /
			(parseFloat(heigth?.replace(",", ".")) *
				parseFloat(heigth?.replace(",", ".")))
		).toFixed(2);
	};

	useEffect(() => {
		methods.setValue("EditNome", paciente?.USUARIO_NOME);
		methods.setValue("EditEmail", paciente?.USUARIO_EMAIL);
		methods.setValue("EditCelular", paciente?.USUARIO_CONTATO);
		methods.setValue(
			"cpf",
			paciente?.USUARIO_CPF?.replace(
				/(\d{3})(\d{3})(\d{3})(\d{2})/,
				"$1.$2.$3-$4"
			)
		);
		methods.setValue(
			"birth_date",
			paciente?.USUARIO_NASCIMENTO == "0000-00-00"
				? ""
				: current_language?.idioma === "Português"
				? `${paciente?.USUARIO_NASCIMENTO?.substr(0, 10)
						.split("-")
						.reverse()
						.join("/")}`
				: current_language?.idioma === "English"
				? `${paciente?.USUARIO_NASCIMENTO?.substr(5, 10)
						.split("-")
						.join("/")}/${paciente?.USUARIO_NASCIMENTO?.substr(0, 4)}`
				: `${paciente?.USUARIO_NASCIMENTO?.substr(0, 10)
						.split("-")
						.reverse()
						.join("-")}`
		);
		methods.setValue(
			"EditAltura",
			`${
				paciente?.USUARIO_ESTATURA != null && paciente?.USUARIO_ESTATURA != ""
					? paciente?.USUARIO_ESTATURA?.split(".").join(",")
					: ""
			}`
		);
		methods.setValue(
			"EditMassa",
			`${
				paciente?.USUARIO_MASSA != null && paciente?.USUARIO_MASSA != ""
					? paciente?.USUARIO_MASSA?.split(".").join(",")
					: ""
			}`
		);
		methods.setValue("EditSexo", paciente?.USUARIO_SEXO);
		methods.setValue(
			"EditIMC",
			paciente?.USUARIO_MASSA && paciente?.USUARIO_ESTATURA
				? `${formatIMC(
						paciente?.USUARIO_MASSA,
						paciente?.USUARIO_ESTATURA
				  )}0 kg/m²`
				: "-"
		);
		methods.setValue("EditLadoDominanteSup", paciente?.USUARIO_LADO_DOMINANTE);
		methods.setValue(
			"EditLadoDominanteInf",
			paciente?.USUARIO_LADO_DOMINANTE_INF
		);
		methods.setValue("EditEntranceDoor", paciente?.ID_PORTA_ENTRADA);
		methods.setValue("EditMatricula", paciente?.USUARIO_MATRICULA);
		methods.setValue("EditManagement", paciente?.ID_GERENCIA);
		methods.setValue("EditPosition", paciente?.ID_CARGO);
	}, [paciente]);

	useEffect(() => {
		if (management?.length > 0) {
			const managementName = management?.map(
				(item: any) => item?.GERENCIA_TITULO
			);
			setManagementList(managementName);
		}

		if (entrance_door_data?.length > 0) {
			const doorList = entrance_door_data?.map(
				(item: any) => item?.PORTA_ENTRADA_TITULO
			);
			setEntranceDoorList(doorList);
		}

		if (positionsDynalabs?.length > 0) {
			const positionsDynalabsList = positionsDynalabs?.map(
				(item: any) => item?.CARGO_TITULO
			);

			setPositionList(positionsDynalabsList);
		}
	}, [management, entrance_door_data, positionsDynalabs]);

	const onSubmit = (data: any) => {
		const findManagementOnList = management?.find(
			(item: any) => item?.GERENCIA_TITULO == data?.EditManagement
		);

		const findEntrancedoorOnList = entrance_door_data?.find(
			(item: any) => item?.PORTA_ENTRADA_TITULO == data?.EditEntranceDoor
		);

		const findPositionOnList = positionsDynalabs?.find(
			(item: any) => item?.CARGO_TITULO == data?.EditPosition
		);

		const dat_request = {
			USUARIO_NIVEL: "3",
			USUARIO_NOME: data?.EditNome,
			USUARIO_EMAIL: data?.EditEmail,
			USUARIO_CONTATO: data?.EditCelular,
			USUARIO_CPF: data?.cpf,
			USUARIO_ESTATURA: data?.EditAltura?.replace("m", ""),
			USUARIO_MASSA: data?.EditMassa?.replace("kg", "").replace("k", ""),
			USUARIO_NASCIMENTO:
				current_language?.idioma === "Português"
					? data?.birth_date?.split("/").reverse().join("-")
					: current_language?.idioma === "English"
					? `${data?.birth_date?.substr(6, 10)}-${data?.birth_date
							?.substr(0, 5)
							.split("/")
							.reverse()
							.join("-")}`
					: data?.birth_date.split("-").reverse().join("-"),
			USUARIO_SEXO: data?.EditSexo?.split("")[0],
			USUARIO_CONDICIONAMENTO: condition
				? conditioning?.indexOf(condition)
				: "",
			USUARIO_LADO_DOMINANTE:
				!dominant || dominant === current_language?.lado_dominante
					? ""
					: formatDominantForSave(dominant, current_language),
			USUARIO_LADO_DOMINANTE_INF:
				!dominant || dominant === current_language?.lado_dominante
					? ""
					: formatDominantForSave(dominant, current_language),
			ID_PORTA_ENTRADA: findEntrancedoorOnList
				? findEntrancedoorOnList?.ID_PORTA_ENTRADA
				: paciente?.ID_PORTA_ENTRADA,
			USUARIO_MATRICULA: data?.EditMatricula,
			ID_GERENCIA: findManagementOnList
				? findManagementOnList?.ID_GERENCIA
				: paciente?.ID_GERENCIA,
			ID_CARGO: findPositionOnList
				? findPositionOnList?.ID_CARGO
				: paciente?.ID_CARGO,
		};

		dispatch(
			AddPacAvalActions.set_avatar_eval_64(
				user_eval_avatar_64 != null
					? user_eval_avatar_64
					: paciente?.USUARIO_FOTO
			)
		);
		AmplitudeLog("edit_perfil_paciente", { body: dat_request });
		dispatch(AddPacAvalActions.set_edit_paci(paciente));
		dispatch(AddPacAvalActions.request_add_evaluetor(dat_request));
		setLoad(false);
	};
	return (
		<Content img={img} style={{ width: "100%" }}>
			<Form
				ref={formRef}
				methods={methods}
				onSubmit={(data) => {
					onSubmit(data), setLoad(true);
				}}
			>
				<div
					style={{
						width: "100%",
						display: "flex",
						flexDirection: "row",
						justifyContent: "space-between",
					}}
				>
					<P2Desk></P2Desk>
					<div
						className="ContainerPhoto"
						onClick={() => (!disabled ? setClickAddPhoto(true) : {})}
					>
						<div
							className="Photo"
							style={{
								cursor: !disabled ? "pointer" : "default",
								position: "relative",
							}}
						>
							<input
								id="img"
								type="file"
								ref={inputRef}
								onChange={(event) => (!disabled ? getBase64(event) : {})}
								onClick={(event) => (!disabled ? deletePhoto(event) : {})}
								style={{ display: "none" }}
								accept="image/*"
							/>
							{img ? (
								<img src={img} className="imgForInput" />
							) : (
								<UserWhitoutPhoto
									color={Colors.white}
									width={"3rem"}
									height={"3rem"}
								/>
							)}
							{img && !disabled && (
								<div
									className="Camera"
									style={{
										position: "absolute",
										bottom: 0,
										right: 0,
										zIndex: 2,
									}}
								>
									<Camera color={Colors.white} />
								</div>
							)}
						</div>
					</div>
					<Title>
						<ContainerIcon onClick={() => setDisabled(!disabled)}>
							<Edit
								color={Colors.primary_blue_k_main}
								className="EditInformations"
							/>
						</ContainerIcon>
					</Title>
				</div>

				<ContainerInfos img={img}>
					<div>
						<div className="ContainerBlock">
							<div className="ContainerInsideBlock">
								<InputTextEntryForm
									type="text"
									width={90}
									title={
										current_language?.nome_completo + (disabled ? "" : "*")
									}
									placeholder={current_language?.placeholder_digite}
									fontFamily="NotoSans-SemiBold"
									fontWeight={600}
									fontSize={1}
									disabled={disabled}
									typeInputName="EditNome"
									marginRight={20}
								/>
								<InputTextEntryForm
									type="text"
									width={90}
									disabled={disabled}
									title={
										current_language?.menu_lateral_data_nascimento +
										(disabled ? "" : "*")
									}
									placeholder={current_language?.placeholder_digite}
									leftIcon="Calendar"
									fontFamily="NotoSans-SemiBold"
									fontWeight={600}
									typeInputName="birth_date"
									maxLength={10}
								/>
							</div>

							<div className="ContainerInsideBlock">
								<InputTextEntryForm
									type="number"
									width={90}
									title={current_language?.primeiro_acesso_CPF}
									disabled={disabled}
									placeholder={"__.__.__-_"}
									leftIcon="DigitalIcon"
									fontFamily="NotoSans-SemiBold"
									fontWeight={600}
									typeInputName="cpf"
									maxLength={14}
									marginTop={20}
									marginRight={20}
								/>
								<InputTextEntryForm
									type="text"
									width={90}
									marginTop={20}
									disabled={disabled}
									title={current_language?.primeiro_acesso_celular}
									placeholder={current_language?.placeholder_digite}
									fontFamily="NotoSans-SemiBold"
									fontWeight={600}
									fontSize={1}
									leftIcon="Phone"
									typeInputName="EditCelular"
								/>
							</div>

							<div className="ContainerInsideBlock">
								<InputTextEntryForm
									type="text"
									width={90}
									marginTop={20}
									title={"E-mail"}
									disabled={disabled}
									placeholder={current_language?.placeholder_digite}
									fontFamily="NotoSans-SemiBold"
									fontWeight={600}
									fontSize={1}
									leftIcon="EmailIcon"
									typeInputName="EditEmail"
									marginRight={20}
								/>

								<InputSelectForm
									type="select"
									disabled={disabled}
									title={current_language?.menu_lateral_sexo}
									placeholder={current_language?.select_country}
									rightIcon="ArrowSelect"
									arrayOptions={Sex}
									fontFamily="NotoSans-SemiBold"
									fontWeight={600}
									fontSize={1}
									width={90}
									marginTop={20}
									typeInputName="EditSexo"
								/>
							</div>
						</div>

						{isWorklabActive && (
							<div className="ContainerBlock">
								<div className="ContainerInsideBlock">
									<InputSelectForm
										type="select"
										disabled={disabled}
										title={current_language?.porta_entrada}
										placeholder={current_language?.selecione}
										rightIcon="ArrowSelect"
										arrayOptions={entranceDoorList}
										fontFamily="NotoSans-SemiBold"
										fontWeight={600}
										fontSize={1}
										marginTop={20}
										marginRight={20}
										width={90}
										typeInputName="EditEntranceDoor"
									/>

									<InputSelectForm
										type="select"
										disabled={disabled}
										title={current_language?.gerencia}
										placeholder={current_language?.selecione}
										rightIcon="ArrowSelect"
										arrayOptions={managementList}
										fontFamily="NotoSans-SemiBold"
										fontWeight={600}
										fontSize={1}
										marginTop={20}
										width={90}
										typeInputName="EditManagement"
									/>
								</div>

								<div className="ContainerInsideBlock">
									<InputSelectForm
										type="select"
										disabled={disabled}
										title={current_language?.cargo}
										placeholder={current_language?.selecione}
										rightIcon="ArrowSelect"
										arrayOptions={positionList}
										fontFamily="NotoSans-SemiBold"
										fontWeight={600}
										fontSize={1}
										marginTop={20}
										marginRight={20}
										typeInputName="EditPosition"
									/>

									<InputTextEntryForm
										type="text"
										width={90}
										marginTop={20}
										title={current_language?.matricula}
										placeholder={current_language?.placeholder_digite}
										fontFamily="NotoSans-SemiBold"
										fontWeight={600}
										fontSize={1}
										disabled={disabled}
										typeInputName="EditMatricula"
									/>
								</div>
							</div>
						)}
					</div>

					<div className="ContainerBlock">
						<div className="ContainerInsideBlock">
							<InputTextEntryForm
								type="text"
								disabled={disabled}
								title={current_language?.menu_lateral_massa}
								placeholder={current_language?.placeholder_digite}
								fontFamily="NotoSans-SemiBold"
								fontWeight={600}
								fontSize={1}
								leftIcon="Mass"
								typeInputName="EditMassa"
								marginTop={20}
								marginRight={20}
							/>

							<InputTextEntryForm
								type="text"
								marginTop={20}
								disabled={disabled}
								title={current_language?.menu_lateral_altura}
								placeholder={current_language?.placeholder_digite}
								fontFamily="NotoSans-SemiBold"
								fontWeight={600}
								fontSize={1}
								leftIcon="Height"
								typeInputName="EditAltura"
							/>
						</div>

						<div className="ContainerInsideBlock">
							<div className="w-full">
								<Text
									title={"IMC"}
									fontFamily="NotoSans-Regular"
									fontSize={1}
									fontWeight={600}
									textAlign="left"
									marginTop={20}
									textColor={Colors?.primary_blue_k_main}
								/>
								<Text
									title={
										methods.watch("EditMassa") != "" &&
										methods.watch("EditAltura") != ""
											? `${formatIMC(
													methods.watch("EditMassa")?.toString(),
													methods.watch("EditAltura")?.toString()
											  )}kg/m²`
											: "kg/m²"
									}
									fontFamily="NotoSans-Regular"
									fontSize={1}
									fontWeight={400}
									textAlign="left"
									marginTop={20}
									textColor={Colors?.neutral_grey_k_60}
								/>
							</div>

							<InputSelectForm
								type="select"
								disabled={disabled}
								title={current_language?.lado_dominante_inferiores}
								descriptionTitle={current_language?.lado_perna}
								placeholder={current_language?.selecione}
								rightIcon="ArrowSelect"
								arrayOptions={DominantSides}
								fontFamily="NotoSans-SemiBold"
								fontWeight={600}
								fontSize={1}
								marginTop={20}
								marginLeft={20}
								typeInputName="EditLadoDominanteInf"
								dataChildToParent={(data) => {
									setDominant(data);
								}}
							/>
						</div>

						<div className="ContainerInsideBlock">
							<InputSelectForm
								type="select"
								disabled={disabled}
								title={current_language?.menu_lateral_condicionamento}
								placeholder={current_language?.select_country}
								rightIcon="ArrowSelect"
								arrayOptions={conditioning}
								fontFamily="NotoSans-SemiBold"
								fontWeight={600}
								fontSize={1}
								marginRight={20}
								dataChildToParent={(data) => {
									setCondition(data);
								}}
								marginTop={24}
								typeInputName="EditConditioning"
							/>

							<InputSelectForm
								type="select"
								disabled={disabled}
								title={current_language?.lado_dominante_superiores}
								descriptionTitle={current_language?.lado_mao}
								placeholder={current_language?.selecione}
								rightIcon="ArrowSelect"
								arrayOptions={DominantSides}
								fontFamily="NotoSans-SemiBold"
								fontWeight={600}
								fontSize={1}
								marginTop={20}
								typeInputName="EditLadoDominanteSup"
								dataChildToParent={(data) => {
									setDominant(data);
								}}
							/>
						</div>
					</div>
				</ContainerInfos>
				{!disabled && (
					<FormSubmiteButton
						type="submit"
						onClick={() => methods.trigger()}
						disabled={
							methods.watch("EditNome") != "" &&
							methods.watch("birth_date") != ""
								? false
								: true
						}
						marginTop={40}
						fontFamily="Kanit-Medium"
						typeButtonComponent="primary"
						activityIndicator={load}
						title={current_language?.menu_lateral_botao_salvar}
					/>
				)}
			</Form>
			<ModalSaveChangeEditPatient
				visible={modalVisible}
				save={(data: boolean) => setSubmitForm(data)}
				cancel={() => {
					dispatch(DashBoardActions.set_current_page("perfil_paciente")),
						setModalVisible(false);
				}}
			/>
		</Content>
	);
};

export default InformacoesPaciente;
